import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Collapsible from '../../../components/common/Collapsible';


const TabTwoSection = ({ tab, sidebarStatus }) => {
  if (sidebarStatus !== 'done' || _.isEmpty(tab)) {
    return null;
  }
  const tabTwoSection = _.map(tab, (val, key, idx) => {
    let contentOrLinks = null;

    if (val.view_content) {
      contentOrLinks = (<div className="link"
                             dangerouslySetInnerHTML={{ __html: val.view_content }}
                             key={`contentlink${idx}`} />);
    } else if (val.links) {
      contentOrLinks = val.links.map((p, i) => <div className="link"
                                                    dangerouslySetInnerHTML={{ __html: p }}
                                                    key={`searchlink${i}`} />);
    }

    if (_.includes(val.class || [], 'collapsible')) {
      return (
        <div key={key} className="tab-section tab-section-2">
          <Collapsible
            initCollapsed={false}
            title={val.title}>
            {contentOrLinks}
          </Collapsible>
        </div>
      );
    }
    let title = null;
    if (val.title) {
      title = <div className="title" dangerouslySetInnerHTML={{ __html: val.title }} />;
    }
    if (val.href) {
      title = <a className="title link" href={`/${val.href}`} dangerouslySetInnerHTML={{ __html: val.title }} />;
    }

    return (
      <div className="tab-section tab-section-2" key={key}>
        {title}
        { contentOrLinks }
      </div>
    );
  });

  return (
    <React.Fragment>
      { tabTwoSection }
    </React.Fragment>
  );
};

TabTwoSection.defaultProps = {
  tab: {},
}

TabTwoSection.propTypes = {
  tab: PropTypes.object,
  sidebarStatus: PropTypes.string.isRequired,
};

export default TabTwoSection;



// WEBPACK FOOTER //
// ./src/pages/filings/FacetsBlock/TabTwoSection.jsx